"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const React = require("react");
const components_overlay_Toggletip_hooks_useToggletip = require("../../../../chunks/useToggletip-BCyf9wPQ.js");
const clsx = require("../../../../chunks/clsx-CBkIpawf.js");
require("../../../../foundations/icons/IconsDefault.js");
const foundations_typography_Text_Text = require("../../../../foundations/typography/Text/Text.js");
const components_overlay_Toggletip_components_ToggletipIcon = require("./ToggletipIcon.js");
const Toggletip_module = require("../../../../chunks/Toggletip.module-DA5jkCaB.js");
const ToggletipExplainer = React.forwardRef(function ToggletipExplainer2({ ariaLabel, showLabel, variant, className }, propRef) {
  const context = components_overlay_Toggletip_hooks_useToggletip.useToggletipContext();
  const ref = components_overlay_Toggletip_hooks_useToggletip.useMergeRefs([context.refs.setReference, propRef]);
  return /* @__PURE__ */ jsxRuntime.jsxs(
    "button",
    {
      "aria-label": showLabel ? void 0 : ariaLabel,
      ref,
      className: clsx.clsx(
        Toggletip_module.styles.toggletipExplainer,
        showLabel ? Toggletip_module.styles.toggletipButton : Toggletip_module.styles.toggletipTrigger,
        className
      ),
      type: "button",
      ...context.getReferenceProps({
        // Prevent navigation if wrapped in a link
        onClick: (e) => {
          e.preventDefault();
        }
      }),
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(components_overlay_Toggletip_components_ToggletipIcon.ToggletipIcon, { isActive: context.open, variant }),
        showLabel && /* @__PURE__ */ jsxRuntime.jsx(
          foundations_typography_Text_Text.Text,
          {
            component: "span",
            variant: "caption",
            className: clsx.clsx(Toggletip_module.styles[`toggletip-${variant}-text`]),
            children: ariaLabel
          }
        )
      ]
    }
  );
});
exports.ToggletipExplainer = ToggletipExplainer;
